export const CCR_CONTENT = {
  DIRECTORY_ARTIST: 'directory:artist',
  DIRECTORY_PLAYLIST: 'directory:playlist',
  PLAYLIST: 'playlist',
};
